
import Vue from 'vue';
import isMobileView from '@root/common/utils/isMobileView';
import { PodcastCategory } from '@root/modules/podcast/types/podcast';
import Category from '@root/modules/podcast/components/fragments/Category.vue';

interface Props {
  category: PodcastCategory;
  shouldLoadMoreCategories: boolean;
}

interface Data {
  isMobileView: boolean;
}

interface Methods {
  loadMoreCategories: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    Category,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    shouldLoadMoreCategories: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      isMobileView: false,
    };
  },
  watch: {
    shouldLoadMoreCategories: {
      handler(value) {
        if (process.client && !value) {
          window.removeEventListener('scroll', this.loadMoreCategories);
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadMoreCategories() {
      const d = document.documentElement;
      const w = document.querySelector('.podcast-category') as HTMLElement;
      if (w) {
        const offsetThreshold = d.clientHeight + 500;
        const userHasScrolled = window.scrollY > 200;
        const offset = window.scrollY + offsetThreshold;

        if (userHasScrolled && offset >= w.offsetHeight) {
          this.$emit('load-more-categories');
        }
      }
    },
  },
  mounted() {
    this.isMobileView = isMobileView();

    // Load more episodes on scroll
    window.addEventListener('scroll', this.loadMoreCategories);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.loadMoreCategories);
  },
});
